























































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
@Component({
  name: "PdfIndex",
})
export default class PdfIndex extends Vue {}
